import * as angular from "angular";
import {IController, ILogService} from "angular";
import {AgreementsRequests} from "../../services/agreements-requests-service.service";
import {AgreementDialogService} from "../../services/agreement-dialog-service.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {SitesAlertsService} from "../../../sites/services/sites-alerts.service";

export class AgreementsViewCtrl implements IController {
  agreements: any;

  constructor(private agreementDialogService: AgreementDialogService, private bringozLoaderService: BringozLoaderService,
              private agreementsRequests: AgreementsRequests, private $log:ILogService, private sitesAlertsService: SitesAlertsService) {
  }


  onCreateAgreement(event) {
    this.agreementDialogService.createAgreement(event)
      .then((agreementToCreate) => {
        this._createAgreement(agreementToCreate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  private _createAgreement(agreement) {
    this.agreementsRequests.createAgreement(agreement)
      .then((createdAgreement) => {
        this.agreements.unshift(createdAgreement);
        this.agreements = this.agreements.concat([]);
        this.sitesAlertsService.createAgreementSuccess();
      })
      .catch((error) => {
        this.sitesAlertsService.createAgreementError();
        this.$log.info('Failed to create agreement @agreementsView@onCreateAgreement', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }


}

angular
  .module('bringoz.admin.agreements')
  .component('agreementsView', {
    bindings: {
      agreements: '<'
    },
    template: require('./agreements-view.html').default,
    controller: AgreementsViewCtrl
  });
